import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDocs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 53" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#979797">
      <g transform="translate(8.889 7.778)">
        <circle cx={11.111} cy={12.222} r={11.111} />
        <ellipse cx={11.111} cy={12.222} rx={5.556} ry={11.111} />
        <path d="M.314 11.913h21.768M11.413.961V23.29" />
      </g>
      <path d="M2 .5A1.5 1.5 0 0 0 .5 2v48.111a1.5 1.5 0 0 0 1.5 1.5h36a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 38 .5H2zM8.889 40H30.17" />
    </g>
  </svg>
);
const Memo = memo(SvgDocs);
export default Memo;
